/**
 * Determines if a profile photo was imported vs manually uploaded
 * @param photoUrl - The photo URL or path from S3
 * @returns true if photo was imported, false if manually uploaded
 */
export const isImportedPhoto = (photoUrl: string | null | undefined): boolean => {
    if (!photoUrl) return false;
    return (
        photoUrl.includes('profile-photos-import/') || photoUrl.includes('profile-photos-import%2F')
    );
};
